/* GOPSHOP 2.0 – animierter Aurora-Shader für den Hero.
   Läuft nur, solange der Hero sichtbar ist; bei "Weniger Bewegung" wird ein Standbild gezeichnet.
   Ohne WebGL bleibt der CSS-Verlauf des Hero sichtbar. */
(function () {
  if (window.__gopShader) return;
  window.__gopShader = true;

  var FRAG = [
    'precision mediump float;',
    'uniform vec2 r; uniform float t; uniform vec2 m;',
    'float h(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}',
    'float n(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);',
    ' return mix(mix(h(i),h(i+vec2(1.,0.)),f.x),mix(h(i+vec2(0.,1.)),h(i+1.),f.x),f.y);}',
    'float fbm(vec2 p){float v=0.,a=.5;for(int i=0;i<5;i++){v+=a*n(p);p*=2.03;a*=.5;}return v;}',
    'void main(){',
    ' vec2 p=(gl_FragCoord.xy-.5*r)/r.y; p+=(m-.5)*.12;',
    ' float T=t*.05;',
    ' vec2 q=vec2(fbm(p*1.5+vec2(T,-T)),fbm(p*1.5+vec2(3.1-T,1.7+T)));',
    ' float f=fbm(p*2.1+q*1.9+vec2(T*1.4,-T*.8));',
    ' float glow=smoothstep(.45,1.,f)*(1.-smoothstep(.1,1.35,length(p-vec2(.45,.2))));',
    ' vec3 teal=vec3(.22,.98,.86), deep=vec3(.0,.22,.24);',
    ' vec3 col=mix(vec3(.004,.016,.014),deep,smoothstep(.25,.85,f))*.85;',
    ' col+=teal*pow(glow,1.7)*.95;',
    ' col+=teal*.06*smoothstep(.55,1.,q.y);',
    ' col*=1.-.6*smoothstep(.35,1.25,length(p*vec2(.9,1.2)));',
    ' gl_FragColor=vec4(col,1.);',
    '}'
  ].join('\n');

  var VERT = 'attribute vec2 a;void main(){gl_Position=vec4(a,0.,1.);}';

  function init(canvas) {
    var gl = canvas.getContext('webgl', { antialias: false, alpha: false, powerPreference: 'low-power' });
    if (!gl) return;

    function compile(type, src) {
      var s = gl.createShader(type);
      gl.shaderSource(s, src);
      gl.compileShader(s);
      return gl.getShaderParameter(s, gl.COMPILE_STATUS) ? s : null;
    }

    var vs = compile(gl.VERTEX_SHADER, VERT);
    var fs = compile(gl.FRAGMENT_SHADER, FRAG);
    if (!vs || !fs) return;

    var prog = gl.createProgram();
    gl.attachShader(prog, vs);
    gl.attachShader(prog, fs);
    gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return;
    gl.useProgram(prog);

    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(prog, 'a');
    gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

    var uR = gl.getUniformLocation(prog, 'r');
    var uT = gl.getUniformLocation(prog, 't');
    var uM = gl.getUniformLocation(prog, 'm');

    // Halbe Auflösung reicht für den weichen Verlauf und schont Akku/GPU
    var scale = Math.min(window.devicePixelRatio || 1, 1.5) * 0.5;
    var mouse = [0.5, 0.5];
    var target = [0.5, 0.5];
    var visible = true;
    var running = false;
    var start = performance.now() - Math.random() * 20000;
    var last = 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function resize() {
      var w = Math.max(1, Math.round(canvas.clientWidth * scale));
      var hgt = Math.max(1, Math.round(canvas.clientHeight * scale));
      if (canvas.width !== w || canvas.height !== hgt) {
        canvas.width = w;
        canvas.height = hgt;
        gl.viewport(0, 0, w, hgt);
      }
    }

    var dirty = true;
    if ('ResizeObserver' in window) new ResizeObserver(function () { dirty = true; }).observe(canvas);
    function draw(now) {
      if (dirty) {
        dirty = false;
        resize();
      }
      mouse[0] += (target[0] - mouse[0]) * 0.04;
      mouse[1] += (target[1] - mouse[1]) * 0.04;
      gl.uniform2f(uR, canvas.width, canvas.height);
      gl.uniform1f(uT, (now - start) / 1000);
      gl.uniform2f(uM, mouse[0], mouse[1]);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
    }

    function loop(now) {
      if (!visible || document.hidden) {
        running = false;
        return;
      }
      // ~30 fps genügen
      if (now - last > 32) {
        last = now;
        draw(now);
      }
      requestAnimationFrame(loop);
    }

    function kick() {
      if (reduce || running || !visible || document.hidden) return;
      running = true;
      requestAnimationFrame(loop);
    }

    draw(performance.now());
    canvas.classList.add('is-ready');

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        kick();
      }).observe(canvas);
    }
    document.addEventListener('visibilitychange', kick);
    window.addEventListener('resize', function () {
      dirty = true;
      if (reduce) draw(performance.now());
    });
    window.addEventListener(
      'pointermove',
      function (e) {
        target[0] = e.clientX / window.innerWidth;
        target[1] = 1 - e.clientY / window.innerHeight;
      },
      { passive: true }
    );
    kick();
  }

  function boot() {
    document.querySelectorAll('canvas[data-gop-shader]').forEach(function (c) {
      if (c.dataset.gopReady) return;
      c.dataset.gopReady = '1';
      init(c);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Theme-Editor: Section neu geladen
  document.addEventListener('shopify:section:load', function () {
    window.__gopShader = true;
    boot();
  });
})();
